import { viewSchemas } from "@redotech/redo-views-common/views";
import * as z from "zod";

export const saveReplenishmentReportView = {
  name: "saveReplenishmentReportView" as const,
  input: z.object({ view: viewSchemas["replenishment-report"] }),
  output: z.object({}),
};
